<div class="card storyboard-item">
  <img (click)="open(item)" class="card-img-top" [src]="item.cover_image.sizes.small.url" alt="Card image cap" />
  <div class="card-block card-body">
    <h4 class="card-title" (click)="open(item)">{{item.title}}</h4>
  </div>
  <div class="card-footer">
    <div class="storyboard-date">
      <div class="date">{{item.created_at | amDateFormat:'DD'}}</div>
      <div class="date-details">
        <div class="month">{{item.created_at | amDateFormat:'MMMM \'YY'}}</div>
        <div class="time">{{item.created_at | amDateFormat:'hh:mm A'}}</div>
      </div>
    </div>
    <div ngbDropdown class="d-inline-block float-right folder-menu dropup" [placement]="'top'">
      <span class="fa fa-ellipsis-h toggle-points" id="storyboardMenu" ngbDropdownToggle></span>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="storyboardMenu">
        <button class="dropdown-item download" [disabled]="!item.last_video_export" [routerLink]="['/storyboard-publish', item.id]"><i class="fa fa-download"></i> Download</button>
        <button class="dropdown-item" [routerLink]="['/storyboard', item.id]"><i class="fa fa-pencil"></i> Edit</button>
        <button class="dropdown-item duplicate" (click)="duplicate()"><i class="fa fa-files-o"></i> Duplicate</button>
        <button class="dropdown-item" (click)="delete()"><i class="fa fa-trash"></i> Delete</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/storyboard-item/storyboard-item.component.html